<template>
    <Modal
        v-bind="$attrs"
        v-on="$listeners"
        class-name="modal-container"
        :value="value"
        :width="width"
        @input="onInput"
    >
        <div ref="qrcode" class="qrcode"></div>
        <div style="text-align: center" class="body-class">
            <p class="text">{{ text }}</p>
        </div>
        <div slot="footer" style="text-align: center; padding: 15px 0px">
            <Button
                class="btn btn-confirm"
                :loading="modal_loading"
                :style="{ background: btnColor }"
                @click="downloadCode"
                >{{ btnConfirm }}</Button
            >
        </div>
    </Modal>
</template>

<script>
import QRCode from 'qrcode-js'
import { pathJoin, getTenant, qs } from '_u/helper'

export default {
    name: 'CreateQrcode',
    data() {
        return {
            modal_loading: false,
        }
    },
    props: {
        // 提示的内容
        text: {
            type: String,
            default: '可将生成的二维码发送给租客，关注公众号后立即绑定微信账号',
        },
        // 确认按钮文字
        btnConfirm: {
            type: String,
            default: '下载二维码',
        },
        // 确认按钮颜色
        btnColor: {
            type: String,
            default: '',
        },
        // 值
        id: {
            type: String,
            default: '',
        },
        cusName: {
            type: String,
            default: '',
        },
        houseName: {
            type: String,
            default: '',
        },
        value: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: '420px',
        },
    },
    watch: {
        value(val) {
            if (val) {
                var el = this.$refs.qrcode,
                    url =
                        process.env.VUE_APP_RENTER_SERVER +
                        pathJoin(
                            `mobile.html#/bind?${qs.stringify({
                                cusId: this.id,
                                tenantCode: getTenant(),
                                timestamp: new Date().getTime(),
                            })}`
                        )

                el.innerHTML = ''
                new QRCode(el, {
                    text: url,
                    width: 120,
                    height: 120,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H,
                })
                console.log(url)
            }
        },
    },
    methods: {
        onInput(val) {
            this.$emit('input', val)
        },
        // 下载二维码
        downloadCode() {
            var el = this.$refs.qrcode.getElementsByTagName('img')[0],
                a = document.createElement('a'), // 生成一个a元素
                event = new MouseEvent('click') // 创建一个单击事件

            a.download = name || '二维码' // 设置图片名称
            a.href = el.src // 将生成的URL设置为a.href属性
            a.dispatchEvent(event) // 触发a的单击事件

            this.$emit('input', false)
            this.$Message.success('下载成功')
        },
    },
}
</script>

<style lang="less" scoped>
.qrcode {
    margin-top: 40px;
    display: flex;
    justify-content: center;
}
.body-class {
    .text {
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: rgb(51, 51, 51);
        text-align: center;
        padding: 0px 30px;
        margin-top: 30px;
    }
}
.btn {
    width: 135px;
    height: 32px;
    &-confirm {
        background-color: @primary-color;
        color: #ffffff;
    }
}
</style>
<style lang="less">
// 居中
.modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    text-align: center;
    .ivu-modal {
        top: 0;
    }
    // 去除边框
    .ivu-modal-header,
    .ivu-modal-footer {
        border: none !important;
    }
}
</style>
